import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
// Styles are inlined since these components will be rendered for PDF generation
export const TableView = ({ data, columns }) => {
    // else Typescript will complain about the type of value
    const isRenderable = (value) => typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        (typeof value === 'object' && React.isValidElement(value)) ||
        Array.isArray(value);
    return (_jsxs("table", { style: {
            boxSizing: 'border-box',
            width: '100%',
            tableLayout: 'auto',
            borderCollapse: 'separate',
            borderSpacing: 0,
            borderStyle: 'solid',
            textIndent: 0,
            fontFamily: 'sans-serif',
            borderWidth: '1px',
            borderColor: '#e5e7eb',
            borderRadius: 12, // More pronounced rounding for the table
            overflow: 'hidden', // Ensures rounding is visible
        }, children: [_jsx("thead", { "aria-hidden": 'false', style: {
                    boxSizing: 'border-box',
                    width: '100%',
                    borderStyle: 'solid',
                    background: '#F9FAFB', // Slightly lighter for header
                    borderWidth: 0,
                    borderColor: 'currentColor',
                }, children: _jsx("tr", { style: {
                        boxSizing: 'border-box',
                        borderStyle: 'solid',
                        background: '#F9FAFB',
                        borderWidth: 0,
                        borderColor: 'currentColor',
                    }, children: columns.map((column) => (_jsx("th", { style: {
                            boxSizing: 'border-box',
                            borderStyle: 'solid',
                            background: '#F9FAFB',
                            fontWeight: 'bold',
                            color: 'rgba(17, 24, 39, 0.6)',
                            borderWidth: 0,
                            borderBottomWidth: 1,
                            borderBottomColor: '#e5e7eb',
                            paddingLeft: 24,
                            paddingRight: 24,
                            textAlign: 'left',
                            borderRadius: 0,
                            paddingTop: 16,
                            paddingBottom: 16,
                            width: 150,
                            fontSize: 16,
                        }, children: _jsx("div", { style: {
                                display: 'flex',
                                gap: 8,
                                alignItems: 'center',
                            }, children: _jsx("span", { style: {
                                    margin: 0,
                                    fontSize: 14,
                                }, children: column.label }) }) }, column.key))) }) }), _jsx("tbody", { style: { boxSizing: 'border-box' }, children: data.map((row, rowIndex) => {
                    const rowKey = columns.map((col) => row[col.key]).join('-') || rowIndex;
                    return (_jsx("tr", { style: {
                            boxSizing: 'border-box',
                            width: '100%',
                            borderStyle: 'solid',
                            borderWidth: 0,
                            borderColor: 'currentColor',
                            background: '#fff',
                            transition: 'background 0.2s',
                            cursor: 'pointer',
                            borderRadius: rowIndex === 0 ? '12px 12px 0 0' : rowIndex === data.length - 1 ? '0 0 12px 12px' : 0,
                        }, children: columns.map((column, colIndex) => {
                            const value = row[column.key];
                            const isFirst = colIndex === 0;
                            const isLast = colIndex === columns.length - 1;
                            const cellStyle = {
                                boxSizing: 'border-box',
                                height: 60,
                                borderStyle: 'solid',
                                borderWidth: 0,
                                borderBottomWidth: 1,
                                borderBottomColor: '#e5e7eb',
                                paddingLeft: 24,
                                paddingRight: 24,
                                paddingTop: 8,
                                paddingBottom: 8,
                                textAlign: 'left',
                                fontSize: 16,
                                width: 150,
                                background: 'transparent',
                                borderRadius: 0,
                            };
                            if (isFirst) {
                                cellStyle.fontWeight = 700;
                                cellStyle.color = 'rgba(17, 24, 39, 1)';
                            }
                            else {
                                cellStyle.fontWeight = 400;
                                cellStyle.color = 'rgba(71, 85, 105, 1)';
                            }
                            if (isFirst && rowIndex === data.length - 1) {
                                cellStyle.borderBottomLeftRadius = 12;
                            }
                            if (isLast && rowIndex === data.length - 1) {
                                cellStyle.borderBottomRightRadius = 12;
                            }
                            // Remove border bottom for all cells in the last row
                            if (rowIndex === data.length - 1) {
                                cellStyle.borderBottomWidth = 0;
                            }
                            return (_jsx("td", { style: cellStyle, children: isRenderable(value) ? (column.render ? column.render(value) : value) : '' }, column.key));
                        }) }, rowKey));
                }) })] }));
};
//# sourceMappingURL=table_view.component.v2.js.map